import type { SportSpec, WireState } from './wire';

export interface SetsConfig {
  sets_to_win: number;
  points_per_set: number;
  final_set_points: number;
  win_by_two: boolean;
}

export interface Pair {
  home_team: number;
  away_team: number;
}

export interface SetsState extends WireState {
  set_state: 'running' | 'finished';
  sets: Pair[];
  current_set: Pair;
}

export const setsSpec: SportSpec<SetsConfig, SetsState> = {
  type: 'sets',
  clocks: () => [],
  runningStateOf: () => 'none',
};
